/*global console*/
define('lib/Podio.Event.UI',['require','jquery','lib/prototype/Function.prototype'],function(require) {

  var $ = require('jquery');
  require('lib/prototype/Function.prototype');

  function proxy_callback(callback, shouldPreserveDefault, e) {
    var target = $(e.currentTarget);
    if (!shouldPreserveDefault) {
      e.preventDefault();
    }
    callback.apply(this, [target].concat(Array.prototype.slice.call(arguments).slice(2)));
  }

  function bind(eventType, selector, fn, shouldPreserveDefault) {
    $(window.document).delegate(selector, eventType, proxy_callback.curry(fn, shouldPreserveDefault));
  }

  function unbind(eventType, selector) {
    $(window.document).undelegate(selector, eventType);
  }

  /** expose external methods **/
  return {
    bind: bind,
    unbind: unbind
  };

});

